<template>
  <a class="bg-primary text-white" @scroll="handleScroll" href="#" id="scroll"><i class="fa fa-angle-up"></i></a>
</template>

<script>
export default {
  name: 'ScrollToTop',
  methods: {
    handleScroll() {
      const arrow = document.querySelector('#scroll')
      if (window.scrollY > 0) {
        arrow.classList.add('visible')
      } else {
        arrow.classList.remove('visible')
      }
    },
  },
  mounted() {
    const body = document.querySelector('body')
    body.onscroll = this.handleScroll
  },
}
</script>
<style>
#scroll {
  border-radius: 0.5rem;
  transition: opacity 0.5s;
  opacity: 0;
}
#scroll.visible {
  transition: opacity 0.5s;
  opacity: 1;
}
</style>
